import { Reveal } from "@/components/landing/Reveal";
import { SITE } from "@/lib/siteConfig";

export const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="bg-navy-900 text-warm-neutral py-24 md:py-32"
  >
    <div className="container-page grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      {/* Professional photograph of Joede C. Brown */}
      <Reveal className="lg:col-span-4">
        <figure data-testid="owner-photo" className="m-0">
          <div className="aspect-[4/5] w-full overflow-hidden rounded-lg border border-warm-neutral/20 bg-navy-800">
            <img
              src="/brand/joede-brown.png"
              alt="Joede C. Brown, MSA — Brown & Associates"
              className="h-full w-full object-cover object-top"
            />
          </div>
          <figcaption className="mt-5">
            <p className="font-heading text-2xl text-warm-neutral leading-tight">
              Joede C. Brown, MSA
            </p>
            <p className="font-body text-sm text-warm-neutral/70 mt-1.5">
              QuickBooks Online Certified ProAdvisor
            </p>
            <p className="font-body text-xs uppercase tracking-[0.22em] text-warm-accent mt-1.5">
              Brown &amp; Associates, LLC
            </p>
          </figcaption>
        </figure>
      </Reveal>

      <Reveal delay={0.1} className="lg:col-span-8">
        <p className="font-body text-xs sm:text-sm uppercase tracking-[0.25em] text-warm-accent mb-5">
          About {SITE.shortName}
        </p>
        <h2 className="font-heading font-semibold text-4xl sm:text-5xl md:text-6xl leading-[1.08] tracking-tight max-w-3xl">
          Professional Bookkeeping Support{" "}
          <span className="italic font-normal text-warm-accent">
            Without the Judgment
          </span>
        </h2>
        <p className="font-body text-base sm:text-lg leading-relaxed text-warm-neutral/80 max-w-2xl mt-8">
          Joede C. Brown, MSA, provides professional bookkeeping support to
          small-business owners who need help understanding, correcting, or
          managing their financial records. {SITE.shortName} offers ongoing
          bookkeeping, bookkeeping cleanup, and detailed reviews designed to help
          business owners determine the appropriate path forward.
        </p>
      </Reveal>
    </div>
  </section>
);

export default About;
